<template>
  <div class="container">
    <wrap-container>
      <section-label
        class="section-label"
        :value="label"
        :label-color="labelColor"
      />
      <ul :class="{ numeric: numeric, 'no-margin': noMargin }">
        <li
          v-for="(val, key) in items()"
          v-bind:key="key"
          :style="{ color: itemColor }"
          v-bind:class="liClass()"
        >
          <span
            class="label"
            :class="{ 'label-light': val.labelLight }"
            v-if="val.label"
            v-html="val.label"
          />
          <p
            class="description"
            v-if="val.description"
            v-html="val.description"
          />
          <span class="detail" v-if="val.detail">
            <img src="@/assets/img/1x/0info_icon.png" alt="info" />
            <span class="detail-text" v-html="val.detail" />
          </span>
        </li>
      </ul>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import SectionLabel from "@/components/core/SectionLabel";
export default {
  name: "OfferGroup",
  components: { WrapContainer, SectionLabel },
  props: {
    label: String,
    itemColor: {
      type: String,
      default: "#535353"
    },
    labelColor: {
      type: String,
      default: "#121212"
    },
    itemIcon: {
      type: String,
      default: "verde"
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    numeric: Boolean
  },
  methods: {
    items() {
      let filter = [];
      /* Filtro solo los Slots que me interesan */
      this.$slots.default.forEach(function(val) {
        if (val.componentOptions && val.componentOptions.propsData) {
          filter.push(val.componentOptions.propsData);
        }
      });
      return filter;
    },

    liClass() {
      return {
        verde: this.itemIcon === "verde" && !this.numeric,
        azul: this.itemIcon === "azul" && !this.numeric,
        rectangle: this.itemIcon === "rectangle" && !this.numeric,
        trapecio: this.itemIcon === "trapecio" && !this.numeric
      };
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  white-space: normal;
  padding-left: 24px;
  margin-bottom: 40px;
}

ul li {
  margin-bottom: 28px;
}

.label >>> em {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-style: normal;
  text-transform: none;
  font-size: 11px;
  vertical-align: super;
}

ul li.verde:before {
  height: 22px;
  width: 22px;
  background-image: url("../../assets/img/1x/icon_ok_green.svg");
  /* Con esto corro la imagen más a la izquierda */
  margin-left: -23px;
  padding-left: 11px;
}

ul li.azul:before {
  height: 22px;
  width: 22px;
  background-image: url("../../assets/img/1x/icon_ok.svg");
  /* Con esto corro la imagen más a la izquierda */
  margin-left: -23px;
  padding-left: 11px;
}

ul li.trapecio:before {
  width: 4px !important;
  height: 8px !important;
  background-image: url("../../assets/img/1x/li-verde.png");
  /* Con esto corro la imagen más a la izquierda */
  margin-left: -19px;
  padding-left: 11px;
  margin-top: 6px;
  margin-right: 15px;
}

ul li.trapecio:not(:last-child) {
  margin-bottom: 15px;
}

ul li.trapecio {
  display: flex;
  align-items: flex-start;
}

ul.numeric {
  list-style-type: decimal;
}

ul li:before {
  content: "";
  display: inline-block;
  background-size: 22px;
  background-repeat: no-repeat;
  vertical-align: top;
}

li {
  font-size: 14px;
  line-height: 1.57;
  margin-bottom: 30px;
}

ul.no-margin li {
  margin-bottom: 0;
}

.section-label {
  margin-bottom: 20px;
}

span.label {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  margin: 0;
}

span.label-light {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}

p.description {
  margin: 0;
}

/* Elementos con detail */
span.detail {
  display: table;
  margin-top: 20px;
}

span.detail * {
  display: table-cell;
}

span.detail img {
  margin-right: 14px;
}

ul li.rectangle::before {
  width: 7px !important;
  height: 4px !important;
  background-color: #1973b8 !important;
  /* Con esto corro la imagen más a la izquierda */
  margin-left: -32px;
  margin-right: 24px;
  margin-top: 8px;
}

li.rectangle {
  margin-bottom: 12px !important;
}
</style>
